import {
  OnCheapestPriceSelection,
  OnCheapestPriceToggleActivation,
  OnCheapestPriceToggleReset,
  OnClickValidation,
  OnConfiguratorSelectionChange,
  OnPackageElementsFetched,
  OnPackageElementsFetchError,
  OnToggleCheapestPrice,
  OnUseConfigurator
} from './configurator.types'

export const ACTIVE_CHEAPEST_PRICE_TOGGLE = 'ACTIVE_CHEAPEST_PRICE_TOGGLE'
export const CHEAPEST_PRICE_SELECTION = 'CHEAPEST_PRICE_SELECTION'
export const CLICK_VALIDATION = 'CLICK_VALIDATION'
export const CONFIGURATOR_SELECTION_CHANGE = 'CONFIGURATOR_SELECTION_CHANGE'
export const FETCH_PACKAGE_ELEMENTS_ERROR = 'FETCH_PACKAGE_ELEMENTS_ERROR'
export const PACKAGE_ELEMENTS_FETCHED = 'PACKAGE_ELEMENTS_FETCHED'
export const RESET_CHEAPEST_PRICE_TOGGLE = 'RESET_CHEAPEST_PRICE_TOGGLE'
export const TOGGLE_CHEAPEST_PRICE = 'TOGGLE_CHEAPEST_PRICE'
export const USE_CONFIGURATOR = 'USE_CONFIGURATOR'

export const onConfiguratorSelectionChange: OnConfiguratorSelectionChange = (
  packageKey, selection, isAutoSelect = false, shouldAutoSelect = true, shouldDetectCheapestPrice = true
) => ({
  payload: {
    isAutoSelect,
    packageKey,
    selection,
    shouldAutoSelect,
    shouldDetectCheapestPrice
  },
  type: CONFIGURATOR_SELECTION_CHANGE
})

export const onPackageElementsFetched: OnPackageElementsFetched = (packageKey, payload) => ({
  payload: {
    ...payload,
    packageKey
  },
  type: PACKAGE_ELEMENTS_FETCHED
})

export const onPackageElementsFetchError: OnPackageElementsFetchError = packageKey => ({
  payload: {
    packageKey
  },
  type: FETCH_PACKAGE_ELEMENTS_ERROR
})

export const onToggleCheapestPrice: OnToggleCheapestPrice = (isToggled, packageKey) => ({
  payload: {
    isToggled,
    packageKey
  },
  type: TOGGLE_CHEAPEST_PRICE
})

export const onCheapestPriceToggleReset: OnCheapestPriceToggleReset = packageKey => ({
  payload: {
    packageKey
  },
  type: RESET_CHEAPEST_PRICE_TOGGLE
})

export const onCheapestPriceToggleActivation: OnCheapestPriceToggleActivation = packageKey => ({
  payload: {
    packageKey
  },
  type: ACTIVE_CHEAPEST_PRICE_TOGGLE
})

export const onCheapestPriceSelection: OnCheapestPriceSelection = (selection) => ({
  payload: {
    selection
  },
  type: CHEAPEST_PRICE_SELECTION
})

export const onClickValidation: OnClickValidation = () => ({
  type: CLICK_VALIDATION
})

export const onUseConfigurator: OnUseConfigurator = () => ({
  type: USE_CONFIGURATOR
})
